import { useId, useState } from 'react'

/**
 * A figure's definition, quoted from the revenue definitions doc: a small button whose
 * tooltip shows on hover, on keyboard focus and on a tap, and hides on Escape or when
 * focus and pointer leave. The text is also the button's accessible description, so a
 * screen reader hears it on focus without opening anything.
 */
export function Definition({ label, text }: { label: string; text: string }) {
  const id = useId()
  const [open, setOpen] = useState(false)
  return (
    <span className="rv-definition" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <button
        type="button"
        className="rv-definition__button"
        aria-label={`How ${label} is counted`}
        aria-describedby={id}
        aria-expanded={open}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        onClick={() => setOpen((shown) => !shown)}
        onKeyDown={(event) => {
          if (event.key === 'Escape') setOpen(false)
        }}
      >
        <svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
          <circle cx="8" cy="8" r="6.5" fill="none" stroke="currentColor" strokeWidth="1.3" />
          <rect x="7.25" y="7" width="1.5" height="4.5" rx="0.5" fill="currentColor" />
          <circle cx="8" cy="4.9" r="0.95" fill="currentColor" />
        </svg>
      </button>
      <span id={id} role="tooltip" className="rv-definition__tooltip" data-open={open || undefined}>
        {text}
      </span>
    </span>
  )
}
